const sectionsToRender = [
  {
    id: '#CartDrawer-Header',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Header'
  },
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  },
  {
    id: '#CartDrawer-Summary',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Summary'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.style.visibility = 'visible';
    this.classList.add('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );
    bodyScroll.lock(this.querySelector('#CartDrawer-Body'));
  }

  close() {
    this.classList.remove('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.style.visibility = 'hidden';
      },
      { once: true }
    );
    removeTrapFocus(this.activeElement);
    bodyScroll.unlock(this.querySelector('#CartDrawer-Body'));
    this.querySelector('#CartDrawer-Body').scrollTop = 0;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.querySelector('#CartDrawer');
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response) {
    this.renderSections(response);
    this.open();
  }

  renderSections(response) {
    this.getSectionsToRender().forEach(section => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/**
 * Opens the cart drawer.
 *
 * Usage: openCart()
 */
window.openCart = function () {
  document.querySelector('cart-drawer')?.open();
};

/**
 * Refreshes the cart UI (drawer, cart counter and/or the standalone cart
 * page) to reflect the current cart state, without changing its contents.
 * Use this after modifying the cart through a custom integration (e.g. an
 * app or a custom fetch call) so the theme's cart sections stay in sync.
 *
 * Usage: updateCart()
 *
 * @returns {Promise<Object>} the parsed cart state returned by Shopify.
 */
window.updateCart = function () {
  const cartDrawer = document.querySelector('cart-drawer');
  const cartItems = document.querySelector('cart-items');
  const sections = new Set(['cart-counter']);

  if (cartDrawer) {
    cartDrawer
      .getSectionsToRender()
      .forEach(section => sections.add(section.section));
  }
  if (cartItems) {
    cartItems
      .getSectionsToRender()
      .forEach(section => sections.add(section.section));
  }

  return fetch(routes.cart_update_url, {
    ...fetchConfig(),
    ...{
      body: JSON.stringify({
        updates: {},
        sections: Array.from(sections),
        sections_url: window.location.pathname
      })
    }
  })
    .then(response => response.json())
    .then(state => {
      if (cartDrawer) cartDrawer.renderSections(state);
      if (cartItems) cartItems.renderSections(state);
      return state;
    });
};
